module.exports = __webpack_public_path__ + "media/dripantwerp.f4b5cf59.mp4";